import React from "react"

import { classNames } from "../../utils/class-names"
import Caption from "../caption"
import UniversalLink from "../universal-link"
import * as styles from "./index.module.scss"
import { getBlogCategoryPath } from "./utils"

interface Props {
  text: string
}

const BlogTag: React.FC<Props> = ({ text }) => {
  return (
    <UniversalLink
      to={getBlogCategoryPath(text)}
      className={classNames(styles.root)}
      trackingProperties={{
        tagName: text,
      }}
    >
      <Caption variant="v1">{text}</Caption>
    </UniversalLink>
  )
}

export default BlogTag
